module.exports = {"513231100":"阿坝镇","513231101":"贾洛镇","513231200":"哇尔玛乡","513231201":"麦昆乡","513231202":"河支乡","513231203":"龙藏乡","513231204":"求吉玛乡","513231205":"甲尔多乡","513231206":"各莫乡","513231207":"德格乡","513231208":"四洼乡","513231209":"安斗乡","513231210":"柯河乡","513231211":"垮沙乡","513231212":"安羌乡","513231213":"查理乡","513231214":"茸安乡","513231215":"洛尔达乡","513231216":"麦尔玛乡","513231400":"若柯河农场","513231401":"贾柯河牧场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/513231.json
// module id = 2223
// module chunks = 0